import {post, upload} from "../api"
import * as url from "../url";

const apiPostFileUpload = data => {
  return upload(data.url, data.history, data.file, {headers: {'Content-Type': 'multipart/form-data'}})
}

const apiPostInboxNotificationUploadFiles = data => {
  return post(url.API_NOTIFICATIONS + "notification-upload-files/", data.history, data.data)
}

export {
  apiPostFileUpload,
  apiPostInboxNotificationUploadFiles,
}
